<script setup lang="ts">
const showDialog = ref(false);
</script>

<template>
  <v-chip
    size="x-small"
    color="primary"
    variant="tonal"
    class="ml-2 font-weight-bold"
    label
    style="cursor: pointer"
    @click.prevent.stop="showDialog = true"
  >
    Beta
  </v-chip>

  <v-dialog v-model="showDialog" max-width="440">
    <v-card rounded="lg">
      <v-card-title class="text-h6 pt-5 px-5">
        Arvee Events is in public beta
      </v-card-title>
      <v-card-text class="px-5 pb-5">
        <p class="mb-3">
          We're still building — we wanted the community to have a way to
          organize for the season as quickly as possible.
        </p>
        <p class="mb-3">
          Everything works end-to-end: creating events, committing, payments,
          and ticketing are all live. But you may encounter rough edges, and
          we're adding new features regularly.
        </p>
        <p class="text-medium-emphasis mb-0">
          If something seems off, let us know at
          <a href="mailto:support@arvee.io" class="text-primary">
            support@arvee.io
          </a>
          — your feedback shapes what we build next.
        </p>
      </v-card-text>
      <v-card-actions class="px-5 pb-4">
        <v-spacer />
        <v-btn color="primary" variant="tonal" @click="showDialog = false">
          Got it
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
